import { render, staticRenderFns } from "./NomeMedico.vue?vue&type=template&id=c6a7f016&"
import script from "./NomeMedico.vue?vue&type=script&lang=js&"
export * from "./NomeMedico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports